var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppIcon = function SvgAppIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 17.111v7.778A3.11 3.11 0 0 1 24.889 28H3.11A3.11 3.11 0 0 1 0 24.889V3.11A3.11 3.11 0 0 1 3.111 0h7.778v3.111H3.11V24.89H24.89V17.11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 6.222H21.78V0h-3.111v6.222h-6.223v3.111h6.223v6.223h3.11V9.333h6.223z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppIcon);
export { ForwardRef as ReactComponent };